exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tc-accordion .acdn-title a[data-v-6e755dc3]:after,\r\n.tc-accordion .acdn-title a.collapsed[data-v-6e755dc3]:after{\r\n    content: ''\n}\r\n", ""]);

// exports
